import { AppBar, Box, createTheme, ThemeProvider, Toolbar, Typography, Link } from "@mui/material";

const logoImg = require('../../_assets/images/HC_Logo.png');

const theme = createTheme({
    typography: { fontFamily: "'Georgia', serif" },
    palette: { primary: { main: "#8A1C1C" } },
});

const appBarSx = {
    backgroundColor: "white",
    color: "#8A1C1C",
    boxShadow: "none",
    borderBottom: "1px solid #ddd",
    p: 0,
};

export const AppToolbar = (params: { toggleSidebar: () => void; isOpen: boolean }) => {
    return (
        <ThemeProvider theme={theme}>
            <AppBar position="fixed" sx={appBarSx}>
                <Toolbar
                    sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        p: "5px 20px",
                        ml: { xs: 0, md: "200px" },
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: "bold", color: "#8A1C1C" }}>
                            Heritage <br /> in Schools
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            borderLeft: "1px solid #8A1C1C",
                            height: { xs: 36, sm: 46, md: 50 },
                            mx: "12px",
                        }}
                    />

                    <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                        <Link href="https://www.heritageinschools.ie/" underline="none" sx={{ display: "flex", alignItems: "center" }}>
                            <Box
                                component="img"
                                src={logoImg}
                                alt="Heritage in Schools"
                                sx={{
                                    display: "block",
                                    mr: "12px",
                                    height: { xs: 36, sm: 50, md: 60 },
                                    width: "auto",
                                }}
                            />
                        </Link>
                    </Box>
                </Toolbar>
            </AppBar>
        </ThemeProvider>
    );
};
